import React from 'react'
import styles from './InviteButton.scss'
import {InviteWidgetContainer} from 'common/InviteWidget'
import cx from 'classnames'
import {FormattedMessage as T} from 'react-intl'

export class InviteButton extends React.PureComponent {
  constructor (props) {
    super(props)
    this.state = {
      showModal: false
    }
  }

  showModal = () => this.setState({showModal: true})

  hideModal = () => this.setState({showModal: false})

  onConfirmInvites = (friends) => {
    const {onConfirmInvites} = this.props
    this.hideModal()
    onConfirmInvites(friends)
  }

  render () {
    const {showModal} = this.state
    const {invited, className, goalId} = this.props

    return (
      <div className={cx(styles.InviteButton, className)}>
        <a onClick={this.showModal}>
          <T id='InviteButton.inviteFriends' defaultMessage='Invite Friends' />
        </a>
        {showModal &&
          <InviteWidgetContainer
            invited={invited}
            inviteLink={`https://${window.location.host}/goals/${goalId}`}
            onRequestClose={this.hideModal}
            onConfirmInvites={this.onConfirmInvites} />}
      </div>
    )
  }
}
